import React from "react";
import styles from './Loading.module.css';

export default function LoadingSpinner() {
    return (
        <>
            <div className={styles.loaderContent}>
                <div className={styles.loader}></div>
            </div>
        </>
    );
}